import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'
import store from '@/store'
import i18n from './i18n'
import locales from "@/locales";
import * as TYPE from './const.types'
import Home from './views/Home'
import Recherche from './views/Recherche'
import HorizontalScrollView from './views/HorizontalScrollView'
import CollectionList from './views/CollectionList'
import CollectionView from './views/CollectionView'
import JobList from './views/JobList'
import JobView from './views/JobView'
import SampleMineral from './views/SampleMineral'
import SampleFossil from './views/SampleFossil'
import SampleOre from './views/SampleOre'
import SampleRock from './views/SampleRock'
import Drawer from './views/Drawer'
import TourList from './views/TourList'
import TourView from './views/TourView'
import PageView from './views/PageView'
import NotFound from './views/NotFound'
import MainContainer from './components/MainContainer'
import PageList from "@/views/PageList";

const mapTypes = new Map([
  [`node--${TYPE.PAGE}`, PageView],
  [`node--${TYPE.JOB}`, JobView],
  [`node--${TYPE.COLLECTION}`, CollectionView],
  [`taxonomy_term--${TYPE.DRAWER}`, Drawer],
  [`sample--${TYPE.SAMPLE_MINERAL}`, SampleMineral],
  [`sample--${TYPE.SAMPLE_FOSSIL}`, SampleFossil],
  [`sample--${TYPE.SAMPLE_ORE}`, SampleOre],
  [`sample--${TYPE.SAMPLE_ROCK}`, SampleRock],
  [`node--${TYPE.TOUR}`, TourView]
])

const getLocale = lang => {
  return locales.includes(lang) ? lang : locales[0]
}

Vue.use(Router)
Vue.use(VueMeta)

const defaultLangPath = '/fr';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: MainContainer,
      beforeEnter: (to, from, next) => {
        next(defaultLangPath)
      }
    },
    {
      path: '/:lang',
      component: MainContainer,
      beforeEnter: (to, from, next) => {
        i18n.locale = getLocale(to.params.lang)
        load()
          .then(() => {
            if (locales.includes(to.params.lang)) {
              next()
            } else {
              next(defaultLangPath + to.fullPath)
            }
          })
      },
      children: [
        {
          path: '/',
          name: 'home',
          props: {
            searchMode: false
          },
          component: Home
        },
        {
          path: 'metiers',
          alias: 'jobs',
          name: 'jobs',
          component: HorizontalScrollView,
          props: {
            itemType: 'job'
          },
          children: [
            {
              path: '/',
              name: 'job_list',
              component: JobList
            }
          ]
        },
        {
          path: 'collections',
          name: 'collections',
          component: HorizontalScrollView,
          props: {
            itemType: 'collection'
          },
          children: [
            {
              path: '/',
              name: 'collection_list',
              component: CollectionList
            }
          ]
        },
        {
          path: 'pages',
          name: 'pages',
          component: HorizontalScrollView,
          props: {
            itemType: 'pages'
          },
          children: [
            {
              path: '/',
              name: 'pages_list',
              component: PageList
            }
          ]
        },
        {
          path: 'visites',
          alias: 'tours',
          name: 'tours',
          component: HorizontalScrollView,
          props: {
            itemType: 'tour'
          },
          children: [
            {
              path: '/',
              name: 'tour_list',
              component: TourList
            }
          ]
        },
        {
          path: 'recherche',
          alias: 'search',
          name: 'search',
          component: Recherche
        },
        {
          path: 'tiroirs/:id',
          alias: 'drawers/:id',
          name: 'drawers',
          component: Drawer,
          props: true // params as props
        }
      ]
    },
    {
      path: '404',
      name: '404',
      component: NotFound
    },
    {
      path: '*',
      name: 'custom',
      component: MainContainer,
      beforeEnter: (to, from, next) => {
        i18n.locale = getLocale(to.fullPath.split('/')[1])
        Vue.$api.getEntityByPath(i18n.locale, to.path)
          .then(response => {
            const entity = response.data.entity
            if (!entity) return next({ name: 'not_found' })

            const type = `${entity.type}--${entity.bundle}`
            let name = `${type}-${entity.uuid}`

            if (entity.type === 'sample') name = 'sample'

            router.addRoutes(
              [{
                path: to.path,
                component: MainContainer,
                children: [
                  {
                    name: name,
                    path: '',
                    component: mapTypes.get(type),
                    props: { uuid: entity.uuid }
                  }
                ]
              }])

            next(to.path)
          })
          .catch(e => {
            return next({ name: 'not_found' })
          })
      }

    }
  ]
})

function load () {
  return new Promise((resolve, reject) => {
    Vue.$api.getSettings(i18n.locale)
      .then(response => {
        store.dispatch('loaded', response.data)

        resolve(response)
      })
      .catch(e => reject)
  })
}

export default router
